import React from 'react';

import { Controller } from 'react-hook-form';

import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import { CustomizedFormErrorMessage } from 'components/common';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateForm/CreateReportFromTemplateForm.module.scss';
import { UseCreateReportFromTemplateModalLogic } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal.logic';

const NAME_MAX_CHARS = 100;

interface Props {
    logic: UseCreateReportFromTemplateModalLogic['logic'];
}

export const NewReportName = ({ logic }: Props) => {
    return (
        <div className={classes.formField}>
            <label>Report name:</label>
            <Controller
                render={({ field }) => {
                    return (
                        <TextInput
                            {...field}
                            placeholder={'Report name...'}
                            maxLength={NAME_MAX_CHARS}
                            onClear={() => {
                                logic.form.setValue('templateName', '');
                            }}
                        />
                    );
                }}
                name={'templateName'}
                control={logic.form.control}
                rules={{
                    required: 'This field is required',
                    minLength: { value: 2, message: 'Must be at least 2 characters' },
                    maxLength: { value: NAME_MAX_CHARS, message: `Must be no more than ${NAME_MAX_CHARS} characters` },
                }}
            />
            {logic.form.formState.errors.templateName && (
                <CustomizedFormErrorMessage text={logic.form.formState.errors.templateName.message} />
            )}
        </div>
    );
};
